import React from "react"
import {Label} from "reactstrap";

class MultiRadio extends React.Component {
    render() {
        let {options, name, value, onChange} = this.props
        return <div>
            {options.map((item,i) => <div className={"d-inline mr-2"} key={`RadioGroup-${i}`}>
                <div className={`radio${typeof item.color === "string" ? ` radio-${item.color}` : ""}`}>
                    <input id={`item-${item.value || item.slug}`} name={name}
                           onChange={onChange}
                           type="radio"
                           value={item.value || item.slug}
                           checked={value === (item.value || item.slug)}
                    />
                    <label htmlFor={`item-${item.value || item.slug}`}><span
                        className="radio-label"></span> {item.label}</label>
                </div>
            </div>)}
        </div>;
    }
}

export default MultiRadio